'use client';

import React, { createContext, useContext } from 'react';
import useHeader from './useHeader';

type HeaderContextType = ReturnType<typeof useHeader>;

const HeaderContext = createContext<HeaderContextType | null>(null);

export const useHeaderContext = (): HeaderContextType => {
  const context = useContext(HeaderContext);

  if (!context) {
    throw new Error('useHeaderContext must be used within the HeaderContext');
  }

  return context;
};

interface IProps {
  children: React.ReactNode,
}

const HeaderContextProvider = ({ children }: IProps) => (
  <HeaderContext.Provider value={ useHeader() }>
    { children }
  </HeaderContext.Provider>
);

export default HeaderContextProvider;
